export class DashboardListResultCount {
    notReservedResultCount: number = 0;
    cancelledResultCount: number = 0;
    reservationResultCount: number = 0;
    inProgressOperationResultCount: number = 0;
    completedOperationResultCount: number = 0;
}